import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import { useGlobal } from '../context/global/global.context';
import { GlobalActions } from '../context/global/types';
import { menuGeneratorService } from '../services/menu-generator.service';
import { observabilityService } from '../services/observability';
export const useMenuGenerated = (page, size, restaurantName) => {
    const { t } = useTranslation();
    const { state, dispatch } = useGlobal();
    const { auth, country } = state;
    const swrResponse = useSWR({
        key: 'menu-generated',
        page,
        size,
        restaurantName,
        country,
    }, (params) => menuGeneratorService.getMenusGenerated(params), {
        refreshInterval: 15000,
        fallbackData: {
            content: [],
            total_elements: 0,
        },
        onError: (error) => {
            dispatch({
                type: GlobalActions.showNotification,
                payload: { message: t('menuGenerator.table.notification.error'), type: 'error' },
            });
            observabilityService.captureError({
                error,
                name: 'menu-generated',
                user: auth === null || auth === void 0 ? void 0 : auth.userProfile,
            });
        },
    });
    return swrResponse;
};
